import CircularProgress from '@mui/material/CircularProgress';
import styled from "styled-components"

const AdminLoadingWrapper = styled.div`
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 80vh;
`

function AdminLoading() {
    return (
        <AdminLoadingWrapper className="admin_loading">
            <CircularProgress />
        </AdminLoadingWrapper>
    );
}

export default AdminLoading;
